/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link, withRouter } from "react-router-dom";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Container,
    InputGroup,
    InputGroupText,
    InputGroupAddon,
    Input,
    Button,
    Breadcrumb,
    BreadcrumbItem
} from "reactstrap";

import routes from "routes.js";
import AuthService from "services/auth.service";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Deco from "security/deco"
import ToolSelector from "components/ToolSelector/ToolSelector"
import PageContext from "contexts/PageContext"

class Header extends React.Component {
    static contextType = PageContext;

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            dropdownOpen: false,
            color: "transparent",
            fullname: ""
        };
        this.toggle = this.toggle.bind(this);
        this.dropdownToggle = this.dropdownToggle.bind(this);
        this.sidebarToggle = React.createRef();
    }
    toggle() {
        if (this.state.isOpen) {
            this.setState({
                color: "transparent",
            });
        } else {
            this.setState({
                color: "dark",
            });
        }
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }
    dropdownToggle(e) {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }
    getBrand() {
        return this.props.title;
    }
    openSidebar() {
        document.documentElement.classList.toggle("nav-open");
        this.sidebarToggle.current.classList.toggle("toggled");
    }
    // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
    updateColor() {
        if (window.innerWidth < 993 && this.state.isOpen) {
            this.setState({
                color: "dark",
            });
        } else {
            this.setState({
                color: "transparent",
            });
        }
    }
    componentDidMount() {
        window.addEventListener("resize", this.updateColor.bind(this));
        this.getFullNameUser()
    }
    componentDidUpdate(e) {
        if (
            window.innerWidth < 993 &&
            e.history.location.pathname !== e.location.pathname &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
            this.sidebarToggle.current.classList.toggle("toggled");
        }
    }

    logout() {
        AuthService.logout()
    }

    getFullNameUser() {
        const user = JSON.parse(Deco(localStorage.getItem('user')));
        this.setState({ fullname: user.fullname })
    }

    handleGoBack = () => {
        const { backUrl } = this.context;
        if (backUrl) {
            this.props.history.push(backUrl);
        } else {
            this.props.history.goBack();
        }
    }

    renderBreadcrumb() {
        const { breadcrumbItems, hasBreadcrumb } = this.context;

        if (!hasBreadcrumb) {
            return <NavbarBrand href="/">{this.getBrand()}</NavbarBrand>;
        }

        return (
            <div className="d-flex align-items-center">
                <Button
                    color="secondary"
                    size="md"
                    onClick={this.handleGoBack}
                    style={{ marginRight: '15px', fontWeight: 'bold' }}
                >
                    <i className="nc-icon nc-minimal-left mr-1"></i>
                    Quay lại
                </Button>
                <span style={{ fontSize: '1.1rem', color: '#66615b' }}>
                    {breadcrumbItems.map((item, index) => (
                        <span key={index}>
                            {item.to && index !== breadcrumbItems.length - 1 ? (
                                <Link to={item.to} style={{ color: '#66615b', textDecoration: 'none' }}>{item.label}</Link>
                            ) : (
                                <span style={{ fontWeight: index === breadcrumbItems.length - 1 ? 'bold' : 'normal' }}>
                                    {item.label}
                                </span>
                            )}
                            {index < breadcrumbItems.length - 1 && <span style={{ margin: '0 8px' }}>&gt;</span>}
                        </span>
                    ))}
                </span>
            </div>
        );
    }

    render() {
        const { hasBreadcrumb } = this.context || {};

        return (
            <Navbar
                color={
                    this.props.location.pathname.indexOf("full-screen-maps") !== -1
                        ? "dark"
                        : this.state.color
                }
                expand="lg"
                className={
                    this.props.location.pathname.indexOf("full-screen-maps") !== -1
                        ? "navbar-absolute fixed-top"
                        : "navbar-absolute fixed-top " +
                        (this.state.color === "transparent" ? "navbar-transparent " : "")
                }
            >
                <Container fluid>
                    <div className="navbar-wrapper">
                        <div className="navbar-toggle">
                            <button
                                type="button"
                                ref={this.sidebarToggle}
                                className="navbar-toggler"
                                onClick={() => this.openSidebar()}
                            >
                                <span className="navbar-toggler-bar bar1" />
                                <span className="navbar-toggler-bar bar2" />
                                <span className="navbar-toggler-bar bar3" />
                            </button>
                        </div>
                        {this.renderBreadcrumb()}
                        {/* Only show ToolSelector on Update, Plugin, Dll, Language pages */}
                        {!hasBreadcrumb && (window.location.pathname.includes('/update') ||
                            window.location.pathname.includes('/plugin') ||
                            window.location.pathname.includes('/dll') ||
                            window.location.pathname.includes('/language')) && (
                                <div style={{ marginLeft: '20px' }}>
                                    <ToolSelector />
                                </div>
                            )}
                    </div>
                    <NavbarToggler onClick={this.toggle}>
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                    </NavbarToggler>
                    <Collapse
                        isOpen={this.state.isOpen}
                        navbar
                        className="justify-content-end"
                    >
                        <Nav navbar className="nav-mobile">{this.state.fullname}</Nav>
                        <Nav navbar>
                            <NavItem>
                                <div onClick={() => this.logout()} className="nav-link nav-link-mobile btn-rotate">
                                    <div style={{ fontSize: "10pt", cursor: "pointer" }} className="nav-mobile">Đăng xuất</div>
                                </div>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        );
    }
}

export default withRouter(Header);

